export { default } from './Spin';
export * from './Spin.type';
